import { render, staticRenderFns } from "./EditAssetTypeModal.vue?vue&type=template&id=33242939&scoped=true&"
import script from "./EditAssetTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditAssetTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAssetTypeModal.vue?vue&type=style&index=0&id=33242939&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33242939",
  null
  
)

export default component.exports